import React from 'react';
import Comunication from './Comunication';
import ComunicationPhone from './ComunicationPhone';
import ComunicationEmail from './ComunicationEmail';

function WrongPaht() {
  return (
    <>
      <Comunication/>
      <ComunicationPhone/>
      <ComunicationEmail/>
      <div>Hatalı Giriş Yaptınız!</div>
    </>
    
  )
}

export default WrongPaht;